export default {
      id: "settings-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#settings",
      toString: function () {
        return this.url;
      }
    }